/* eslint-disable custom-rules/ban-ethereum-eth-terms */
import type { NetworkData } from '@dynamic-labs-sdk/client';
import { Contract, RpcProvider, cairo } from 'starknet';

import {
  ETH_CONTRACT_ABI,
  ETH_STARKNET_ADDRESS,
  WEI_PER_ETH,
} from '../constants';

type FetchStarknetBalanceParams = {
  address: string;
  networkData: NetworkData;
};

export const fetchStarknetBalance = async ({
  address,
  networkData,
}: FetchStarknetBalanceParams): Promise<string | null> => {
  const provider = new RpcProvider({
    nodeUrl: networkData.rpcUrls.http[0],
  });

  const contract = new Contract(
    ETH_CONTRACT_ABI,
    ETH_STARKNET_ADDRESS,
    provider
  );

  const { balance } = await contract.balanceOf(address);

  return (Number(cairo.uint256(balance.low).low) / WEI_PER_ETH).toFixed(6);
};
